<script setup lang="ts">
import Image from 'primevue/image';

const props = defineProps({
  contentType: {
    type: String,
    required: true,
  },
  imageLoading: {
    type: Boolean,
    required: true,
  },
  thumbnail: {
    type: String,
    required: true,
  },
  image: {
    type: String,
    required: true,
  },
});

const emits = defineEmits<{
  loadingStarted: [];
}>();
</script>
<template>
  <Image
    class="w-40 h-40"
    preview
  >
    <template #image>
      <!-- eslint-disable-next-line vue/html-self-closing -->
      <img
        :src="props.thumbnail"
        :class="['w-full', 'h-full', 'object-cover']"
      />
    </template>
    <template #preview="slotProps">
      <!-- eslint-disable-next-line vue/html-self-closing -->
      <!-- eslint-disable-next-line vue/html-self-closing -->
      <img
        v-if="props.image"
        :src="props.image"
        alt="preview"
        :style="slotProps.style"
        :class="['max-w-screen', 'max-h-screen', 'object-cover']"
      />
      <!-- eslint-disable-next-line vue/html-self-closing -->
      <img
        v-else
        src="/logo-white.png"
        alt="preview"
        class="max-w-screen max-h-screen object-cover animate-pulse p-image-preview-rotate-180"
        :style="slotProps.style"
        :onload="emits('loadingStarted')"
        @click="slotProps.previewCallback"
      />
    </template>
  </Image>
</template>
